<template>
    <div class="con">
        <Card>
            <div class="select-user">
                <h2>Select User</h2>
                <button class="user-btn"
                    @click="routeTo('Home', { 'email': 'korn@mail.com', 'secret_key': '2985487ID7854' })">User 1</button>
                <button class="user-btn"
                    @click="routeTo('Home', { 'email': 'new@mail.com', 'secret_key': '2948487ID6554' })">User 2</button>
                <button class="user-btn"
                    @click="routeTo('Home', { 'email': 'test@mail.com', 'secret_key': '29AF487ID6584' })">User 3</button>
                <button class="user-btn"
                    @click="routeTo('Home', { 'email': 'fail@mail.com', 'secret_key': 'fail9AF487I' })">User 4</button>
            </div>
        </Card>

        <div v-if="userNotFound" class="modal">
            <v-dialog v-model="dialogVisible" persistent max-width="400">
                <div class="dialog-landing">
                    <div class="modal-content">
                        <div
                            style="margin-bottom: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
                            <h2 style="color: red; margin-bottom: 20px;">Login error!</h2>
                            User not found!
                            <div>
                                Please register or contact admin.
                            </div>
                        </div>
                        <button @click="closeBatteryModal()" class="confirm-btn">Confirm</button>
                    </div>
                </div>

            </v-dialog>
        </div>
    </div>
</template>
  
<script>
import Card from "../components/Card.vue"


export default {
    name: "Landing",
    components: {
        Card
    },
    data() {
        return {
            // email: '',
            // secretkey: '',
            // checkEmail: 'test@mail.com',
            // checkSecretkey: '123456',
            userInfo: '',
            userNotFound: false,
            dialogVisible: true,
        }
    },
    methods: {
        // async fetchData() {
        //     try {
        //         let response = await this.$apiFire('User/onGetUserInfo', { "email": "korn@mail.com", "secret_key": "2985487ID7854" }) // Station id
        //         console.log('user api ', response);
        //         this.batteryStation = response;
        //     } catch (error) {
        //         console.log(error);
        //     }
        // },
        // login() {
        //     if (this.email === this.checkEmail && this.secretkey === this.checkSecretkey) {
        //         localStorage.setItem('email', this.email);
        //         localStorage.setItem('secretkey', this.secretkey);
        //         console.log('Go to home page')
        //         this.routeTo('Home')
        //     } else {
        //         console.log('Go to loco')
        //     }
        // },
        async routeTo(route, data) {
            try {
                let response = await this.$apiFire('User/onGetUserInfo', data) // Station id
                if (Object.keys(response).length === 0) {
                    console.log("User not found")
                    this.userNotFound = true
                } else {
                    console.log('user api ', response);
                    this.userInfo = response;
                    console.log(this.userInfo.id)
                    localStorage.setItem('user_id', this.userInfo.id);
                    if (!route) return
                    console.log(route)
                    console.log(typeof (response))
                    this.$router.push({ name: route })
                }

            } catch (error) {
                console.log(error);
            }

        },
        openModal() {
            // this.selectedBatteryForModal = battery;
        },
        closeBatteryModal() {
            this.userNotFound = false;
        },
    },
    // created() {
    //     this.fetchData();
    // },
}
</script>
  
<style scoped>
.form-landing {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.form-landing input {
    border: 1px solid #000;
    outline: none;
    padding: 8px;
    border-radius: 8px;
}

.form-landing button {
    width: 155px;
    height: 56px;
    background: #FE9900;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
}

.con {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}

.select-user {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    /* background: palegoldenrod; */
}

.user-btn {
    background: #FE9900;
    padding: 8px 16px;
    border-radius: 8px;
    height: 56px;
    width: 180px;
    color: #fff;
    font-size: 16px;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    z-index: 99;
}

.dialog-landing {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
}

.confirm-btn {
    font-size: 16px;
    padding: 8px 16px;
    color: #fff;
    background: linear-gradient(50deg, #FE9900 38.93%, #FFCD82 97.25%);
    border-radius: 8px;
    width: 100%;
}
</style>
  